export const Messages = {
  upgradeTo: (version: string) => `Upgrade to ${version}`,
};
